export default {
    TWEET_URL: "https://aitter-twigene.work/tweet",
    // GENERATE_URL: "https://aitter-twigene.work/generate",
    GENERATE_URL: "https://prd-twigene-ugr57vplca-wl.a.run.app/generate",
    SLACK_SERVER_ERROR: "https://hooks.slack.com/services/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",
    SLACK_TWEET: "https://hooks.slack.com/services/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"
}


// WEBPACK FOOTER //
// ./src/components/constants/index.js